import React, { useState } from 'react';

import BrowserSupportModal from '../../modals/BrowserSupportModal';

export const Footer = () => {
  const [showBrowserModal, setShowBrowserModal] = useState(false);
  return (
    <footer
      style={{
        background: '#233B53',
        color: '#fff',
        padding: '15px 20px',
        textAlign: 'center',
      }}
    >
      <div
        style={{
          maxWidth: '1200px',
          margin: '0 auto',
        }}
      >
        <p style={{ margin: '0 0 10px 0', fontSize: '1.1rem', fontWeight: '500' }}>
          Free Pattern Warehouse
        </p>
        <div style={{ marginBottom: '10px', display: 'flex', justifyContent: 'center', gap: '20px', flexWrap: 'wrap' }}>
          <a
            href="/roadmap"
            style={{
              color: '#fff',
              textDecoration: 'underline',
              fontSize: '0.9rem',
              opacity: '0.8'
            }}
          >
            Roadmap
          </a>
          <button
            onClick={() => setShowBrowserModal(true)}
            style={{
              background: 'none',
              border: 'none',
              color: '#fff',
              textDecoration: 'underline',
              cursor: 'pointer',
              fontSize: '0.9rem',
              opacity: '0.8',
              padding: 0
            }}
          >
            Supported Browsers
          </button>
        </div>
        <p style={{ margin: '0', fontSize: '0.9rem', opacity: '0.8' }}>
          © 2025 Free Pattern Warehouse. All rights reserved.
        </p>
        
        <BrowserSupportModal 
          visible={showBrowserModal} 
          onDismiss={() => setShowBrowserModal(false)} 
        />
      </div>
    </footer>
  );
};

export default Footer;